export const SET_DASHBOARD = 'SET_DASHBOARD';
export const SET_DASHBOARD_CHART = 'SET_DASHBOARD_CHART';
export const SET_DASHBOARD_MERCHANDISER = 'SET_DASHBOARD_MERCHANDISER';
export const SET_DASHBOARD_ABSENSI = 'SET_DASHBOARD_ABSENSI';
